import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { Close } from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';
import { GenericModalProps } from '@/types';
import { rootStyles, paperStyles, headerStyles } from './styles';
import { abyssColors } from '@/theme/colors';

export const GenericModal = ({
  open,
  handleClose,
  children,
  title,
  description,
  sx,
  crossIconStyle,
  headerStyleProp,
  backgroundPaperStyle = {},
  titleSx = {},
  descriptionSx = {},
}: GenericModalProps) => {
  const handleCloseModal = (event: React.MouseEvent) => {
    event.stopPropagation();
    handleClose();
  };
  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      sx={{
        rootStyles,
        ...sx,
      }}
    >
      <Paper sx={{ ...paperStyles, ...backgroundPaperStyle }}>
        <Box sx={{ ...headerStyles, ...headerStyleProp }}>
          <Box>
            <Typography variant="h5" sx={titleSx}>
              {title}
            </Typography>
            {description && (
              <Typography
                variant="body1"
                fontSize="1.4rem"
                mt={1}
                sx={{ color: 'info.main', ...descriptionSx }}
              >
                {description}
              </Typography>
            )}
          </Box>
          <IconButton onClick={handleCloseModal}>
            <Close sx={{ color: abyssColors.primary[300], fontSize: '2rem', ...crossIconStyle }} />
          </IconButton>
        </Box>
        <Box
          sx={{
            height: '100%',
          }}
        >
          {children}
        </Box>
      </Paper>
    </Modal>
  );
};
